module.exports = __webpack_public_path__ + "static/media/iron_throne_token.3aa3b7ad.png";